import React, { useEffect } from 'react'

import Head from '../../head'
import { ZoomImage } from '@cms/ui'

const Page = (props) => {
  useEffect(() => {
    document.getElementById('main-content').classList.add('padding-0')
    document.getElementById('main-content').classList.remove('padding-0')
    return () =>
      document.getElementById('main-content').classList.remove('padding-0')
  }, [])

  if (!props.data || !props.data.tileSource) return null
  const { zh_name, en_name, desc: d, thumbnail, tileSource } = props.data

  const desc = `"${en_name}", Chan Kwan-Lok's creations, also named "${zh_name}". Details: ${d}`

  return (
    <>
      <Head
        title={`${en_name} | ${zh_name}`}
        desc={desc}
        img={`${process.env.NEXT_STRAPI_PUBLIC_ENDPOINT}/${thumbnail.responsiveImages.urlPrefix}`}
        ogTitle={`${en_name} | ${zh_name}`}
      />
      <div className="row works-page">
        {tileSource && (
          <ZoomImage
            tileSource={`${process.env.NEXT_STRAPI_PUBLIC_ENDPOINT}/tiles/${tileSource.hash}`}
          />
        )}
        <div className="column">
          <div className="row">
            <div className="bottom-content">
              <h3>{zh_name}</h3>
              <h1>{en_name}</h1>
              <p className="text-center">{d}</p>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default Page

export async function getStaticProps({ params, preview = false }) {
  const { parseData, fetchWork } = await import('../../data')

  const data = parseData(await fetchWork(params.slug), 'works')

  return {
    props: {
      preview,
      data: data,
    },
  }
}

export async function getStaticPaths() {
  const { fetchWorks } = await import('../../data')

  const slugs = await fetchWorks()

  return {
    paths: slugs.map((id) => ({
      params: {
        slug: String(id),
      },
    })),
    fallback: false,
  }
}
